import { CatalogHardwareFormPage } from './CatalogHardwareFormPage';
import { HardwareAdminPage } from './admin/HardwareAdminPage';

export function HardwareListPage() {
  return <HardwareAdminPage />;
}

export function HardwareCreatePage() {
  return <CatalogHardwareFormPage mode="create" />;
}

export function HardwareEditPage() {
  return <CatalogHardwareFormPage mode="edit" />;
}
